import React from 'react';
export const ProductsContext = React.createContext();
export const ProductsDispatcherContext = React.createContext();